export const wced_policy_framework = [
  {
    id: 1,
    name: 'NATIONAL EDUCATION POLICY ACT OF 1996',
    summary: 'shortsummary/NATIONAL EDUCATION POLICY ACT OF 1996.html',
    link: 'NATIONAL EDUCATION POLICY ACT OF 1996.pdf',
    audio_en: 'audio/en/NATIONAL EDUCATION POLICY ACT OF 1996_en.mp3',
    audio_af: 'audio/af/NATIONAL EDUCATION POLICY ACT OF 1996_af.mp3',
    audio_xh: 'audio/xh/NATIONAL EDUCATION POLICY ACT OF 1996_xh.mp3'
  }
];